export default __webpack_public_path__ + "static/SRF 0100S BIO - Fiche de spécifications et données techniques-5accc396f51c0eff963105fab7599181.pdf";